export const MAX_SCORE = 5
